import { Pass } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetPassesQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/passes?limit=10000`
	return useQuery<void, PassesOutput>(url)
}
interface PassesOutput {
	passes: Pass[]
}
